import _regeneratorRuntime from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.regexp.to-string.js";
import moment from "moment";
import { getData } from "@/services/axios";

import { useRoute } from 'vue-router/composables';
import { ref, watch } from 'vue';
export default {
  __name: 'GovForumShow',
  setup: function setup(__props) {
    // @ts-check
    var route = useRoute();
    var forum = ref({});
    var forumList = ref([]);

    var setData = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var data, params;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getData("government_forums/".concat(route.params.id));

              case 2:
                data = _context.sent;
                forum.value = data.items;
                params = new URLSearchParams({
                  target: forum === null || forum === void 0 ? void 0 : forum.value.target,
                  exclude: route.params.id
                });
                _context.next = 7;
                return getData("government_forums?".concat(params.toString()));

              case 7:
                data = _context.sent;
                forumList.value = data.items;

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function setData() {
        return _ref.apply(this, arguments);
      };
    }(); // created


    setData();
    watch(function () {
      return route.params.id;
    }, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return setData();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    return {
      __sfc: true,
      route: route,
      forum: forum,
      forumList: forumList,
      setData: setData,
      moment: moment
    };
  }
};